import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export const sleep = async (ms) => new Promise((r) => setTimeout(r, ms));

export function sanitizePhoneNumber(phone) {
  return phone.replace(/\D/g, '');
}

export function reactSvgComponentToMarkupString(Component, props) {
  return `data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(createElement(Component, props)))}`;
}

export function debounce(cb, timeout = 0) {
  let timer;

  return (...args) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      cb(...args);
    }, timeout);
  };
}

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
};
